module.exports = __webpack_public_path__ + "img/toumingmozhenxingWu.min.52fd36b4.png";